import React from 'react'

import Carousel from 'react-bootstrap/Carousel';

const RenderFile = ({url, sensorName}) => {
  if (url.endsWith('.mp4')) {
    return (
      <video className='d-block w-100 img-fluid' autoPlay loop>
        <source src={url} type='video/mp4' />
      </video>
    );
  } else {
    return (
      <img className='d-block img-fluid' src={url} alt={sensorName} />
    );
  }
}

const CarouselComponent = ({carousel, sensorName}) => {
  return (
    <Carousel fade>
      {carousel &&
        carousel.map((image, i) => (
          <Carousel.Item key={i}>
            <RenderFile url={image} sensorName={sensorName} />
          </Carousel.Item>
        ))}
    </Carousel>
  );
};

export default CarouselComponent;